export const it = {
  // Global
  lang: "it" as const,
  siteName: "AVPS – Associazione Volontari Pronto Soccorso",
  emergency24: "Emergenza 24/24 · Uffici Lun–Ven 9–13",

  // Header nav
  nav: {
    chiSiamo: "Chi siamo",
    storia: "La nostra storia",
    organizzazione: "Organizzazione",
    noiEAnpas: "Noi e ANPAS",
    trasparenza: "Trasparenza",
    nostriMezzi: "I nostri mezzi",
    servizi: "Servizi per la comunità",
    trasportoSanitario: "Trasporto sanitario",
    teleassistenza: "Teleassistenza",
    assistenzaEventi: "Assistenza eventi",
    corsiFormazione: "Corsi di formazione",
    continuitaAssistenziale: "Assistenza Guardia Medica",
    servizioCivile: "Servizio civile",
    emergenza112: "Emergenza 112",
    iniziative: "Iniziative",
    stellaAmbulanza: "Una stella in ambulanza",
    progettiAssociazioni: "Progetti con altre associazioni",
    newsEventi: "News ed eventi",
    news: "News",
    eventi: "Eventi",
    contatti: "Contatti",
    leSedi: "Le sedi",
    lavoraConNoi: "Lavora con noi",
    sostienici: "Sostienici",
    donazioni5x: "5×1000 e donazioni",
    diventaAmico: "Diventa amico AVPS",
    diventaVolontario: "Diventa volontario",
    privacy: "Privacy policy",
    areaRiservata: "Area riservata",
  },

  // Footer
  footer: {
    desc: "Associazione Volontari Pronto Soccorso di Vimercate. Dal 1973 al servizio della comunità con passione e competenza.",
    linkRapidi: "Link rapidi",
    nuoviCorsi: "✦ Nuovi corsi in partenza",
    diventaVol: "✦ Diventa volontario",
    serviziTitle: "Servizi",
    contattiTitle: "Contatti",
    telefono: "Telefono",
    serviziSecondari: "Servizi secondari: Lun–Ven 9:00–13:00",
    emergenzaSoccorso: "Emergenza e soccorso: 24/24 – 7/7",
    copyright: "© {year} AVPS – Associazione Volontari Pronto Soccorso Vimercate. Tutti i diritti riservati.",
    privacy: "Privacy",
    cookie: "Cookie",
    creditVolontari: "Sito realizzato e gestito dai volontari AVPS",
  },

  // Hero slider
  heroSlider: {
    slides: [
      {
        title: "AVPS Vimercate: soccorritori al tuo fianco ogni giorno",
        subtitle: "Dal 1973 AVPS è al servizio della comunità: emergenza sanitaria, trasporti programmati, teleassistenza e formazione al primo soccorso.",
      },
      {
        title: "Emergenza sanitaria e soccorso a Vimercate, 24 ore su 24",
        subtitle: "I nostri soccorritori garantiscono un servizio di emergenza, gestito da Areu, nel territorio di competenza.",
      },
      {
        title: "Ambulanze e trasporto sanitario per il Vimercatese",
        subtitle: "Ambulanze attrezzate, mezzi di soccorso di base e veicoli per il trasporto sanitario a disposizione di chi ha bisogno.",
      },
    ],
    cta1: "Diventa volontario",
    cta3: "Sostienici",
    prevSlide: "Slide precedente",
    nextSlide: "Slide successiva",
    goToSlide: "Vai alla slide {n}",
  },

  // Index page
  index: {
    servicesLabel: "Servizi per la comunità",
    servicesTitle: "Come possiamo aiutarti",
    servicesSubtitle: "I servizi che offriamo alla comunità, ogni giorno.",
    services: [
      {
        title: "Emergenza sanitaria 112",
        desc: "Interventi di emergenza con equipaggi qualificati e mezzi attrezzati, in coordinamento con AREU 112.",
        cta: "In emergenza chiama 112",
      },
      {
        title: "Trasporto sanitario",
        desc: "Ricoveri, dimissioni, visite specialistiche ed esami: un servizio puntuale e confortevole.",
        cta: "Prenota al 039 66 12 112",
      },
      {
        title: "Teleassistenza",
        desc: "Servizio SOS attivo 24/7, con chiamata amichevole settimanale per le persone fragili.",
        cta: "Informazioni: segreteria@avps.it",
      },
      {
        title: "Eventi e manifestazioni",
        desc: "Copertura sanitaria con soccorritori e ambulanze per eventi sportivi, culturali e manifestazioni.",
        cta: "Richiedi copertura sanitaria",
      },
      {
        title: "Corsi di formazione",
        desc: "Primo soccorso, BLSD, disostruzione pediatrica. Per cittadini, aziende e scuole.",
        cta: "Scrivi a segreteria@avps.it",
      },
      {
        title: "Assistenza Guardia Medica",
        desc: "Assistenza sanitaria per bisogni non urgenti, nelle ore serali, notturne e festive.",
        cta: "Chiama il 116117",
      },
    ],
    learnMore: "Scopri di più",
    historyLabel: "La nostra storia",
    historyTitle: "Oltre 50 anni di impegno",
    historyText: "Nata nel 1973 dal sogno di cinque fondatori, AVPS è cresciuta insieme alla sua comunità, mantenendo lo stesso entusiasmo e una formazione costante. Oggi contiamo su centinaia di volontari, decine di mezzi e un impegno che non si è mai fermato.",
    historyBtn: "Scopri la nostra storia",
    stats: [
      { value: "400+", label: "Volontari attivi" },
      { value: "50+", label: "Anni di servizio" },
      { value: "30+", label: "Mezzi operativi" },
      { value: "24/7", label: "Sempre operativi" },
    ],
    since: "Dal 1973",
    fivexTitle: "Dona il tuo 5×1000 ad AVPS",
    fivexText: "Non ti costa nulla: indica il nostro codice fiscale nella tua dichiarazione dei redditi.",
    fivexCf: "Codice Fiscale",
  },

  // CTA section
  cta: {
    title: "Fai la differenza, diventa volontario",
    text: "Entrare in AVPS significa far parte di una famiglia che ogni giorno si impegna per gli altri. Ti formiamo, ti affianchiamo, ti facciamo crescere.",
    btn1: "Diventa volontario",
    btn2: "Sostienici",
  },

  // Contact form
  form: {
    name: "Nome e cognome *",
    namePlaceholder: "Il tuo nome",
    email: "Email *",
    emailPlaceholder: "La tua email",
    phone: "Telefono",
    phonePlaceholder: "Il tuo numero (opzionale)",
    message: "Messaggio *",
    messagePlaceholder: "Come possiamo aiutarti?",
    privacy: "Acconsento al trattamento dei dati personali ai sensi del GDPR. *",
    privacyNote: "Proseguendo confermi di aver letto l’informativa privacy e cookie e autorizzi il trattamento dei dati esclusivamente per la gestione della tua richiesta.",
    privacyError: "Devi accettare la privacy policy per procedere.",
    sending: "Invio in corso...",
    success: "Messaggio inviato con successo! Ti risponderemo al più presto.",
    error: "Si è verificato un errore. Riprova o contattaci direttamente.",
    submit: "Invia messaggio",
    nameRequired: "Il nome è obbligatorio",
    emailInvalid: "Email non valida",
    messageRequired: "Il messaggio è obbligatorio",
  },

  // Chi siamo
  chiSiamo: {
    title: "Chi siamo",
    subtitle: "AVPS – Associazione Volontari Pronto Soccorso di Vimercate. Dal 1973 al servizio della comunità con passione, competenza e dedizione.",
    intro: "AVPS nasce dalla volontà di cinque fondatori di offrire un servizio di pronto soccorso al territorio di Vimercate. Oggi siamo una realtà consolidata, con centinaia di volontari formati, una sede operativa moderna e una flotta di mezzi all'avanguardia. Il nostro impegno quotidiano si traduce in emergenza sanitaria, trasporti programmati, teleassistenza, formazione e molto altro.",
    cards: [
      { title: "La nostra storia", desc: "Dal 1973 al servizio della comunità di Vimercate e del territorio." },
      { title: "Organizzazione", desc: "Organi associativi, volontari e dipendenti che rendono possibile il nostro lavoro." },
      { title: "Noi e ANPAS", desc: "Parte della rete nazionale ANPAS, la più grande organizzazione di volontariato sanitario." },
      { title: "I nostri mezzi", desc: "Una flotta moderna e attrezzata per ogni tipo di intervento." },
    ],
    learnMore: "Scopri di più",
  },

  // Storia
  storia: {
    title: "La nostra storia",
    subtitle: "AVPS è una realtà nata dal sogno dei 5 fondatori, condiviso con un'intera comunità.",
    intro: "Da più di 50 anni mettiamo il nostro impegno al servizio della popolazione, ogni giorno con lo stesso entusiasmo. AVPS nasce nel 1973 dal progetto di 5 persone che volevano offrire alla popolazione un adeguato servizio di soccorso di emergenza. Antonio Aggrazia, Omero Castiglioni, Ciro Gasperoni, Umberto Marchesi e Walter Verderio riuniscono un gruppo di 40 persone che condividono la loro idea e nello stesso anno di fondazione partono i primi corsi di formazione di Pronto Soccorso.",
    timelineTitle: "La storia",
    timeline: [
      { year: "1973", text: "Nasce AVPS dal progetto di 5 fondatori: Antonio Aggrazia, Omero Castiglioni, Ciro Gasperoni, Umberto Marchesi e Walter Verderio. Partono i primi corsi di formazione di Pronto Soccorso." },
      { year: "1974", text: "AVPS stipula la prima convenzione con l'Ente Ospedaliero di Vimercate. Il 16 settembre i volontari fanno il primo turno di Pronto Soccorso." },
      { year: "1975", text: "Viene acquistata \"la Pinellina\", la primissima ambulanza dell'associazione. Grazie ad una raccolta fondi, viene raggiunta da una seconda ambulanza." },
      { year: "1976–1980", text: "Friuli ed Irpinia sono colpiti da terremoti. Un gruppo di volontari AVPS si unisce ai soccorsi, creando l'embrione di quello che sarà, a partire dal 1985, il Dipartimento di Protezione Civile ufficiale." },
      { year: "Anni '80", text: "Cambio generazionale del Consiglio Direttivo. La Regione Lombardia riconosce ufficialmente l'Associazione." },
      { year: "1994", text: "AVPS avvia il servizio di TeleAssistenza domiciliare, per supportare e dare risposte alle persone anziane o sole del territorio Vimercatese." },
      { year: "1996", text: "Il numero 118 diventa in Lombardia il numero unico per le emergenze sanitarie. L'attività viene estesa a tutta la giornata. L'Associazione assume i primi sei dipendenti. Nascono il trasporto dializzati, il trasporto non di emergenza e l'assistenza alle manifestazioni." },
      { year: "1999", text: "Nasce il servizio Prontofarmacia: i volontari del servizio di Teleassistenza forniscono ai cittadini le informazioni sulle farmacie di turno." },
      { year: "2001", text: "Il 23 Settembre, grazie all'amministrazione comunale di Vimercate, viene ristrutturata una palazzina in via Cadorna 28: nasce la nuova sede." },
      { year: "2003", text: "AVPS partecipa alla gestione del Servizio di Continuità Assistenziale, facendo nascere il gruppo dei Volontari di Guardia Medica. Il servizio di emergenza urgenza viene esteso ad Agrate Brianza con una postazione h24." },
      { year: "2010", text: "AVPS crea un percorso di formazione dedicato ai più piccoli, frequentando le scuole come docenti del soccorso: dalle materne alle elementari, alle medie, fino agli istituti superiori." },
      { year: "2011", text: "Nasce il centro prelievi presso la Farmacia Comunale di Ruginello, dove i volontari gestiscono l'affluenza e immettono i dati sui sistemi informatici della ASST." },
      { year: "2017", text: "L'associazione si dota di un CODICE ETICO e vengono creati o modificati vari regolamenti operativi." },
      { year: "2020", text: "Durante la pandemia COVID, AVPS mantiene operativi tutti i servizi e istituisce servizi di consegna a domicilio di farmaci e spesa alimentare." },
      { year: "2021–2023", text: "Vengono donate 3 apparecchiature LUCAS (massaggiatori semiautomatici esterni) per migliorare gli interventi sugli arresti cardiaci." },
    ],
    interventiTitle: "Interventi straordinari AVPS",
    interventi: [
      { year: "1976", event: "Terremoto in Friuli", detail: "Presenza continuativa da maggio a settembre" },
      { year: "1980", event: "Terremoto in Irpinia", detail: "25 giorni in presenza con 6 persone in turni settimanali" },
      { year: "1987", event: "Alluvione in Valtellina", detail: "Una settimana di presenza con 6 persone" },
      { year: "1987", event: "Caduta ATR42 in località Barni (CO)", detail: "2 giorni in presenza con 11 persone" },
      { year: "1987", event: "Esplosione condominio a Lecco", detail: "Un giorno di presenza con 8 persone" },
      { year: "1993", event: "Alluvione a Genova", detail: "4 giorni in presenza con 3 persone" },
      { year: "1994", event: "Alluvione in Piemonte", detail: "6 giorni in presenza con la partecipazione di 120 studenti" },
      { year: "1997", event: "Terremoto in Umbria e Marche", detail: "16 giorni di permanenza con turnazione di 6 persone, gestendo 6 campi base nella zona di Nocera Umbra" },
      { year: "2020", event: "Pandemia COVID", detail: "Mantenuti operativi tutti i servizi, istituiti servizi di consegna a domicilio di farmaci e spesa alimentare e pacchi alimentari per famiglie in difficoltà" },
    ],
    awardsTitle: "Riconoscimenti e onorificenze",
    awards: [
      "Onorificenza ROTARY Foundation of Rotary International: \"I membri della Fondazione Rotary apprezzano il Vostro disinteressato impegno e generoso aiuto.\"",
      "Comune di Vimercate – anno 2020: \"Medaglia d'Argento al Merito Civile\"",
      "Comune di Burago di Molgora – 13 Settembre 2020: \"Un Diamante per la Vita\"",
      "Comune di Concorezzo – anno 2023: \"Medaglia al Valore Civile\"",
    ],
  },

  // Organizzazione
  organizzazione: {
    title: "Organi associativi",
    subtitle: "Nell'assemblea del giorno 04.06.24 si sono definite le cariche associative a seguito delle votazioni svolte nei giorni 25 e 26.05.24.",
    consiglio: "Consiglio direttivo",
    revisori: "Revisori dei conti",
    probiviri: "Probiviri",
    contattiConsiglio: "Per contattare tutti i membri del Consiglio scrivete alla mail:",
    contattiRevisori: "Per contattare tutti i membri dei Revisori dei Conti scrivete alla mail:",
    contattiProbiviri: "Per contattare tutti i membri dei Probiviri scrivete alla mail:",
  },

  // Noi e ANPAS
  noiEAnpas: {
    title: "Noi e ANPAS",
    subtitle: "AVPS fa parte di ANPAS, la più grande organizzazione nazionale di volontariato sanitario, con oltre 100.000 volontari in tutta Italia.",
    p1: "ANPAS – Associazione Nazionale Pubbliche Assistenze – è la più grande organizzazione di volontariato sanitario in Italia. Con oltre 900 associazioni affiliate e più di 100.000 volontari, ANPAS rappresenta un punto di riferimento per il soccorso e l'assistenza su tutto il territorio nazionale.",
    p2: "AVPS è orgogliosamente parte di questa rete, condividendone i valori di solidarietà, formazione continua e servizio alla comunità. Attraverso ANPAS, partecipiamo a progetti nazionali, emergenze di protezione civile e iniziative di sensibilizzazione.",
  },

  // Nostri mezzi
  nostriMezzi: {
    title: "I nostri mezzi",
    subtitle: "Una flotta moderna e attrezzata per garantire interventi rapidi, sicuri e professionali.",
    text: "AVPS dispone di una flotta di oltre 30 mezzi, tra ambulanze di soccorso avanzato, mezzi per il trasporto sanitario programmato e veicoli di supporto. Ogni mezzo è equipaggiato con le più moderne attrezzature medicali e sottoposto a regolare manutenzione per garantire la massima sicurezza.",
    altriMezzi: "Altri veicoli",
    ambulanzeLabel: "Ambulanze e mezzi sanitari",
    veicoliSupportoLabel: "Veicoli di supporto",
    parcoDiServizio: "Il nostro parco di servizio",
    gippone: "GIPPONE LAND ROVER E + UTES",
  },

  // Trasparenza
  trasparenza: {
    title: "Trasparenza",
    subtitle: "Contributi pubblici ricevuti da AVPS, pubblicati ai sensi della normativa vigente.",
    text: "In ottemperanza alla Legge 4 agosto 2017 n. 124 e successive modifiche, AVPS pubblica le informazioni relative ai contributi pubblici ricevuti.",
    percheDonare: "Perché il tuo sostegno è fondamentale",
    percheDonareText: "AVPS opera grazie a una convenzione con AREU (Azienda Regionale Emergenza Urgenza), che copre parte dei costi del servizio di emergenza sanitaria. Tuttavia, questa convenzione da sola non è sufficiente a sostenere tutte le attività solidali che svolgiamo quotidianamente: teleassistenza, formazione nelle scuole, assistenza agli eventi, manutenzione dei mezzi e acquisto di attrezzature salvavita. Per continuare a garantire questi servizi alla comunità, abbiamo bisogno del contributo di tutti.",
    contributi: "Contributi pubblici",
    documentoPdf: "Documento PDF",
  },

  // Servizi
  servizi: {
    title: "Servizi per la comunità",
    subtitle: "Un ventaglio di servizi sanitari e sociali al servizio della comunità, ogni giorno dell'anno.",
    learnMore: "Scopri di più",
    items: [
      { title: "Emergenza sanitaria 112", desc: "Interventi di emergenza con equipaggi qualificati, in coordinamento con AREU." },
      { title: "Trasporto sanitario programmato", desc: "Ricoveri, dimissioni, visite, esami: un servizio puntuale e sicuro." },
      { title: "Teleassistenza", desc: "SOS attivo 24/7 con chiamata amichevole settimanale." },
      { title: "Assistenza eventi", desc: "Copertura sanitaria professionale per manifestazioni ed eventi." },
      { title: "Corsi di formazione", desc: "Primo soccorso, BLSD, disostruzione pediatrica per tutti." },
      { title: "Assistenza Guardia Medica", desc: "Assistenza sanitaria per bisogni non urgenti, nelle ore serali, notturne e festive." },
      { title: "Servizio civile", desc: "Un'esperienza formativa di 12 mesi al servizio della comunità." },
    ],
  },

  // Emergenza 112
  emergenza: {
    title: "Emergenza sanitaria 112",
    subtitle: "Il nostro impegno nell'emergenza-urgenza, in coordinamento con AREU e il sistema 112 della Regione Lombardia.",
    intro: "AVPS opera nell'ambito del sistema di emergenza sanitaria regionale, con equipaggi formati e mezzi attrezzati pronti a intervenire 24 ore su 24. I nostri volontari e dipendenti rispondono alle chiamate inviate dalla Centrale Operativa AREU 112, garantendo interventi rapidi e professionali su tutto il territorio del Vimercatese.",
    personaleTitle: "Personale qualificato",
    personaleDesc: "I nostri equipaggi sono composti da soccorritori altamente formati, costantemente aggiornati attraverso percorsi di formazione e addestramento continuo.",
    lucasTitle: "Tecnologia LUCAS",
    lucasDesc: "Le nostre ambulanze sono dotate del dispositivo LUCAS per le compressioni toraciche meccaniche: un sistema automatico che garantisce un massaggio cardiaco costante e di altissima qualità, anche durante il trasporto.",
    numero112Title: "Numero unico: 112",
    numero112Desc: "Il numero unico di emergenza è il 112, attivo 24 ore su 24, 7 giorni su 7, su tutto il territorio regionale.",
    lucasDetailTitle: "Eccellenza tecnologica: il dispositivo LUCAS",
    lucasDetailP1: "Il LUCAS (Lund University Cardiac Assist System) è un dispositivo per compressioni toraciche meccaniche che si applica sul paziente in arresto cardiaco. A differenza del massaggio manuale, il LUCAS garantisce compressioni costanti, alla profondità e frequenza corrette, senza interruzioni — anche durante le manovre di trasporto o in spazi ristretti.",
    lucasDetailP2: "Questo strumento permette ai nostri soccorritori di concentrarsi sulle altre manovre salvavita, migliorando significativamente la qualità complessiva del soccorso e le probabilità di sopravvivenza del paziente.",
    operativi247: "Operativi 24/7",
    operativi247Desc: "I nostri equipaggi coprono turni di emergenza 24 ore su 24, garantendo la presenza sul territorio in ogni momento.",
    formazioneContinua: "Formazione continua",
    formazioneContinuaDesc: "Ogni soccorritore segue un percorso formativo rigoroso e viene costantemente aggiornato sulle linee guida e i protocolli più recenti.",
    alertEmergenza: "In caso di emergenza sanitaria, chiama immediatamente il 112.",
    alertEmergenzaSub: "Non recarti in sede: la centrale operativa coordinerà l'invio del mezzo più vicino e più adeguato alla situazione.",
    infoTitle: "Hai bisogno di informazioni?",
    infoDesc: "Per domande sul servizio di emergenza o sulla formazione dei nostri equipaggi, scrivici.",
  },

  // Trasporto sanitario
  trasporto: {
    title: "Trasporto sanitario programmato",
    subtitle: "Il servizio è dedicato ai pazienti impossibilitati ad effettuare in modo autonomo trasferimenti a scopo sanitario.",
    intro: "I volontari AVPS sono disponibili al trasporto in ambulanza o su altri mezzi idonei di pazienti che necessitano di recarsi presso strutture sanitarie per visite specialistiche, esami, terapie, oppure per trasferimenti tra strutture (da ospedale a ospedale o casa di cura) e dimissioni (da ospedale a casa).",
    accompagni: "Inoltre sono previsti anche semplici accompagni per effettuare esami specialistici o visite mediche.",
    comePrenotare: "Come prenotare",
    prenotazioneText: "Il servizio è disponibile solo su prenotazione chiamando il nostro centralino al n. 039/6612112, un volontario si prenderà cura della tua richiesta.",
    centralino: "Centralino",
    orariPrenotazione: "Orari del servizio",
    orariLunVen: "Lun–Ven: 9:00–13:00 e 14:00–18:00",
    orariSab: "Sabato: mattina",
  },

  // Teleassistenza
  teleassistenza: {
    title: "Servizio di Teleassistenza",
    subtitle: "I volontari del servizio di Teleassistenza svolgono un servizio dedicato alle persone anziane, sole o con gravi problemi di salute.",
    intro: "La Teleassistenza è un moderno sistema di supporto a distanza: tramite un telecomando collegato ad un particolare terminale (SOS) installato presso il suo domicilio, l'assistito può, in qualsiasi momento, mettersi in contatto con i Volontari Avps in servizio presso la loro sede di Vimercate (il progetto è svolto in collaborazione con i comuni del territorio e con l'azienda consortile Offerta Sociale).",
    attivo247: "Il servizio è attivo 24 ore su 24, 365 giorni l'anno.",
    attivitaTitle: "Le attività che svolgono i nostri volontari",
    attivitaItems: [
      "Una chiamata amichevole settimanale con ogni Assistito, in orario prestabilito",
      "Coordinano il soccorso in caso d'incidente domestico, malore, caduta accidentale…",
    ],
    chiamataAmichevoleTitle: "La chiamata amichevole",
    chiamataAmichevoleText: "Con cadenza settimanale i volontari Avps contattano i loro assistiti per informarsi sul loro stato di salute e sulle loro esigenze, lo confortano, lo stimolano o anche solo gli tengono compagnia. I volontari sono adeguatamente formati, grazie ad un corso tenuto appositamente da istruttori AVPS.",
    chiamataAmichevoleText2: "La chiamata viene effettuata sempre dallo stesso volontario (dato che i turni dei volontari sono fissi, così come l'appuntamento settimanale concordato anche con la famiglia). In questo modo l'assistito potrà avere un interlocutore conosciuto, di cui fidarsi, con cui sarà più semplice e piacevole interagire.",
    chiamataAmichevoleText3: "La chiamata amichevole serve anche ad effettuare il test sull'efficienza dei dispositivi. È fondamentale che chi usufruisce del servizio di Teleassistenza, soprattutto se anziano, sia in grado di attivare correttamente la chiamata d'emergenza in caso di necessità.",
    chiamataAmichevoleText4: "Grazie ai volontari, gli anziani si abituano, di chiamata in chiamata, a portare sempre con loro il telecomando e ad utilizzarlo correttamente.",
    chiamataEmergenzaTitle: "La chiamata d'emergenza",
    chiamataEmergenzaText: "L'assistito può mettersi in qualsiasi momento in contatto con gli operatori AVPS, attraverso un radio-comando da portare al collo o in tasca. Questo strumento può essere facilmente attivato con la semplice pressione di un pulsante.",
    chiamataEmergenzaText2: "L'allarme dell'utente viene inviato al ricevitore digitale dell'Associazione, il quale fa apparire sul computer del volontario la schermata di emergenza con la scheda individuale dell'utente. L'operatore a questo punto chiama subito l'assistito sul dispositivo vivavoce installato da Avps.",
    chiamataEmergenzaText3: "Se l'assistito risponde, l'operatore attiva prontamente l'intervento più adeguato, dalla semplice chiamata di cortesia fino alla richiesta di mezzi di soccorso. Se l'assistito non risponde, è un segnale d'allarme: l'operatore telefona al primo familiare o amico registrato e si adopera fino alla risoluzione del problema.",
    comeAttivare: "Come si attiva il servizio di teleassistenza?",
    comeAttivareText: "Per attivare il servizio, è necessario rivolgersi all'ufficio Servizi Sociali del comune di residenza dell'assistito. I comuni che usufruiscono del servizio di Teleassistenza sono quelli che aderiscono ad Offerta Sociale.",
    comuniCoperti: "Comuni coperti dal servizio",
    comuni: ["Agrate Brianza","Aicurzio","Arcore","Basiano","Bellusco","Bernareggio","Burago Molgora","Busnago","Camparada","Caponago","Carnate","Cavenago Brianza","Concorezzo","Cornate d'Adda","Correzzana","Grezzago","Lesmo","Masate","Mezzago","Ornago","Pozzo d'Adda","Roncello","Ronco Briantino","Sulbiate","Trezzano Rosa","Trezzo sull'Adda","Usmate Velate","Vaprio d'Adda","Vimercate"],
    infoEmail: "Per informazioni: segreteria@avps.it",
  },

  // Assistenza eventi
  assistenzaEventi: {
    title: "Assistenza a manifestazioni ed eventi",
    subtitle: "Avete necessità di assistenza sanitaria per una manifestazione o un evento?",
    intro: "Avps svolge questo servizio di assistenza sanitaria durante manifestazioni od eventi organizzati nel nostro territorio (in particolare quelli che richiamano un rilevante afflusso di persone) mediante la disponibilità di equipaggi con soccorritori volontari appiedati o se il tipo di evento lo richiede, anche con la presenza di una o anche più ambulanze.",
    normativa: "Regione Lombardia il 7 Ottobre 2014, con DGR n. 2453, ha introdotto un nuovo regolamento in materia di sicurezza e ha previsto una procedura obbligatoria a cui devono attenersi tutti gli organizzatori.",
    tempiAnticipo: "Ti informiamo che occorre predisporre la procedura con anticipo a secondo del tipo di rischio (15 giorni prima della data se evento è a basso rischio, 30 giorni per un rischio medio, 45 giorni per un rischio alto).",
    proceduraTitle: "Questa è la procedura",
    steps: [
      "Vai sulla piattaforma G.A.M.E.S. e procedi con la registrazione.",
      "Inizia la registrazione guidata sulla piattaforma G.A.M.E.S.",
      "Rispondi a tutte le domande che ti saranno poste sulla piattaforma per stabilire se serve ed eventualmente che tipo di copertura sanitaria è necessaria per l'evento.",
      "Salva la bozza di quanto creato (attenzione non inviarla in questa fase). Prima di confermare è compito tuo cercare un'associazione che possa fornirti il servizio di cui hai bisogno.",
      "Chiama Colombo Noemi di Avps al n. +39 335 129 7812 oppure manda una mail a servizisportivi@avps.it. Comunicale i risultati ottenuti sulla piattaforma (calcolo di Rischio ed il Coefficiente Maurer) e tutti gli estremi del servizio (orari, luogo e tipologia) e prendi accordi con lei.",
      "Se il coefficiente Maurer dovesse indicare che non è necessario fornire una copertura sanitaria durante l'evento, potrai comunque scegliere di richiedere un supporto. In tal caso, devi indicarlo al momento della registrazione.",
      "Una volta concordato il tutto e confermata la disponibilità da parte di A.V.P.S. Vimercate, potrai completare la registrazione sulla piattaforma G.A.M.E.S.: indica i Volontari Vimercate come soggetto garante della sicurezza sanitaria e invia il tutto.",
      "Se tutto è stato compilato correttamente riceverai un'email di approvazione, in caso contrario un'email con indicato l'eventuale errore/inesattezza.",
    ],
    contattoOperativo: "Contatto operativo",
    contattoInfo: "Per avere ulteriori informazioni contatta il Referente:",
    richiediCopertura: "Richiedi copertura sanitaria",
    piattaformaGames: "Piattaforma G.A.M.E.S.",
    piattaformaGamesDesc: "Clicca qui per accedere alla piattaforma G.A.M.E.S. e richiedere l'assistenza sanitaria per la tua manifestazione.",
    piattaformaGamesUrl: "https://games.areu.lombardia.it",
  },

  // Corsi formazione
  corsi: {
    title: "Formazione",
    subtitle: "AVPS conferma il suo impegno nell'attività formativa rivolta a tutta la cittadinanza.",
    intro: "AVPS svolge un'intensa attività di formazione interna rivolta ai propri volontari/dipendenti con lo scopo di mantenere sempre efficace la formazione così da poter svolgere il proprio compito operativo in modo consapevole, preparato ed autonomo.",
    intro2: "Organizziamo corsi di formazione rivolti a tutta la popolazione, che rappresenta il primo anello della catena del soccorso poiché siamo convinti che una maggiore diffusione della cultura del primo soccorso sia di fondamentale importanza non solo per i più giovani, ma per l'intera comunità.",
    argomentiTitle: "I principali argomenti trattati nei nostri corsi",
    argomenti: [
      "La modalità di allerta del soccorso 112",
      "Il Primo Soccorso",
      "Le manovre di Rianimazione Cardio-Polmonare anche con l'utilizzo del Defibrillatore Automatico Esterno",
      "Le manovre salvavita di Disostruzione Pediatrica",
    ],
    altriArgomenti: "Altri specifici argomenti possono essere concordati con noi.",
    scuoleTitle: "Nelle scuole",
    scuoleIntro: "I corsi sono rivolti agli studenti delle scuole di ogni ordine e grado e sono adattati alle loro diverse età. L'obiettivo è quello di creare dei percorsi formativi, fin dalla scuola dell'infanzia, volti ad una maggiore diffusione della cultura del Primo Soccorso anche attraverso la conoscenza del sistema Emergenza/Urgenza in Lombardia.",
    scuoleItems: [
      { title: "Progetti per i più piccoli", desc: "Chiunque può fare la differenza in una situazione di emergenza. Molti bimbi hanno chiamato i soccorsi salvando la vita a genitori e nonni. I nostri corsi mirano a rendere i più piccoli consapevoli del corretto comportamento da seguire in caso di emergenza sanitaria. Il progetto scuole di AVPS nasce nel 2007, con i primi corsi tenuti nelle scuole dell'infanzia e primarie dell'istituto comprensivo Don Milani di Vimercate." },
      { title: "Progetti per i giovani", desc: "Da diversi anni gli studenti seguono progetti di formazione in materia di soccorso sanitario nelle scuole medie e superiori del Vimercatese. Lo scopo è quello di rendere i più giovani consapevoli del contributo che possono dare in caso di emergenza. Attraverso corsi altamente pratici, i ragazzi hanno modo di apprendere le tecniche di primo soccorso e le manovre di rianimazione cardio-polmonare anche con l'uso del DAE." },
      { title: "Corsi di emergenza pediatrica", desc: "Attraverso le reti dedicate, Consultori, Associazioni di Genitori, trattiamo questo specifico argomento rivolto ai genitori, ai nonni e a chiunque sia a contatto con i bambini. Organizziamo corsi anche per il personale docente delle Scuole dell'Infanzia." },
      { title: "Corsi BLSD operatore laico", desc: "Questi corsi sono rivolti a tutta la cittadinanza. I corsi di formazione per operatori laici hanno una durata di cinque ore e forniscono l'abilitazione regionale all'utilizzo del Defibrillatore semi-Automatico Esterno integrata con indicazioni sul trattamento in età pediatrica e per la disostruzione delle vie aeree." },
    ],
    ctaText: "Per ogni informazione scrivi a:",
    ctaBtn: "segreteria@avps.it",
  },

  // Guardia medica
  guardiaMedica: {
    title: "Assistenza Guardia Medica (Continuità Assistenziale)",
    subtitle: "I volontari del gruppo di Guardia Medica svolgono un servizio essenziale per la comunità.",
    intro: "I volontari del gruppo di Guardia Medica (o Continuità Assistenziale) svolgono il servizio di:",
    servizi: [
      "Accoglienza delle persone presso la Casa di Comunità",
      "Eventuale accompagnamento dei medici a casa del paziente",
    ],
    sede: "Sede del servizio",
    sedeIndirizzo: "Casa di Comunità a Vimercate in via Giuditta Brambilla, 11 (sito di fronte all'ospedale di Vimercate)",
    accessoAppuntamento: "Non si può accedere senza appuntamento.",
    coseFareTitle: "Cosa fare nel caso di bisogno?",
    coseFareText: "Chiamare il 116117 per richiedere assistenza, prestazioni o consigli sanitari non urgenti.",
    coseFareText2: "Chiamando questo numero il cittadino viene messo in contatto con un operatore competente che attraverso una valutazione telefonica, trasferisce la richiesta verso il servizio di riferimento.",
    orari: "Orari del servizio",
    orariFeriali: "Giorni feriali: dalle 20:00 alle 8:00",
    orariPrefestivi: "Giorni festivi e prefestivi: 24 ore su 24",
    alertEmergenza: "⚠️ Per situazioni di soccorso sanitario ed invio di mezzi di soccorso il numero da comporre è il 112.",
    richiestaInfo: "Richiedi informazioni",
    richiestaInfoText: "Per domande sul servizio di Continuità Assistenziale, scrivici.",
    locandinaLabel: "Scarica la locandina informativa",
    avvisoSospensioneTitle: "Avviso importante",
    avvisoSospensioneText: "A partire dal 1° aprile 2026 il servizio svolto dai volontari AVPS presso la Continuità Assistenziale è sospeso. Il servizio di Guardia Medica resta comunque attivo: per assistenza non urgente chiamare il 116117.",
  },

  // Servizio civile
  servizioCivile: {
    title: "AVPS ed il Servizio Civile Universale",
    subtitle: "Vuoi partecipare anche tu?",
    cosETitle: "Il Servizio Civile Universale",
    cosEText: "Il Servizio Civile Universale rappresenta un'importante opportunità per i giovani di impegnarsi in progetti significativi, contribuendo al benessere della comunità ed acquisendo una preziosa esperienza.",
    cosEText2: "AVPS attraverso la rete ANPAS aderisce a questo progetto. Durante i mesi di esperienza presso l'Avps, i giovani riceveranno una formazione utile per la loro crescita personale e per lo svolgimento dei servizi ai quali saranno dedicati. Avranno inoltre la possibilità di sperimentare le molteplici attività e conoscere le varie realtà presenti nell'Associazione.",
    dettagli: "Dettagli pratici",
    dettagliItems: [
      "Durata del servizio: 12 mesi",
      "Impegno: 25 ore settimanali",
      "Indennità mensile: circa 500,00 euro",
    ],
    requisitiTitle: "Requisiti per partecipare",
    requisitiItems: [
      "Avere un'età compresa tra i 18 e 28 anni",
      "Essere cittadini italiani",
      "Non avere precedenti penali",
    ],
    bandoInfo: "Il bando 2026 è aperto! La scadenza per candidarsi è prorogata al 16 aprile 2026 alle ore 14:00. La procedura di candidatura si svolge esclusivamente online tramite il portale del Dipartimento delle Politiche Giovanili.",
    infoEmail: "Per maggiori informazioni: segreteria@avps.it",
    candidati: "Candidati ora",
    sitoSCU: "Sito Dipartimento SCU",
    bannerTitle: "Bando Servizio Civile 2026",
    bannerText: "2.569 posti nelle pubbliche assistenze ANPAS. 12 mesi, 25 ore settimanali, contributo mensile di circa €520. Hai tra i 18 e i 28 anni? Candidati entro il 16 aprile!",
    bannerDeadline: "Scadenza: 16 aprile 2026 ore 14:00",
    bannerDaysLeft: "giorni rimasti",
    bannerBadge: "Bando aperto",
    bannerCta: "Scopri di più",
    bannerApply: "Candidati online",
    bannerInfo: "Info sul bando ANPAS",
  },

  // Corso Soccorritore
  corsoSoccorritore: {
    badge: "Iscrizioni aperte",
    kicker: "Corso Regionale di",
    title: "Soccorritore",
    claim: "Il prossimo sei tu: impara, entra in squadra, fai la differenza!",
    date: "Martedì 20 ottobre 2026",
    time: "Ore 21.00",
    venue: "Oratorio di Velasca",
    address: "Via E. De Amicis 3/5 — Velasca, Vimercate",
    presentationNote: "Serata di presentazione del corso",
    intro: "Il corso è gratuito ed è destinato a chi intende prestare servizio sui mezzi d'emergenza e di trasporto sanitario.",
    modulesTitle: "Presentazione del corso",
    modules: [
      { name: "Modulo TS", hours: "46 ore", cert: "Certificazione di \"Operatore per il Trasporto Sanitario\"" },
      { name: "Modulo SSE", hours: "78 ore", cert: "Qualifica Regionale di \"Soccorritore Esecutore\"" },
    ],
    infoTitle: "Per informazioni",
    email: "info@avps.it",
    phone: "039 661 2112",
    ctaInfo: "Richiedi informazioni",
    ctaCall: "Chiama 039 661 2112",
    ctaMore: "Scopri il corso",
    daysLeft: "giorni alla presentazione",
    posterAlt: "Locandina del Corso Regionale di Soccorritore AVPS del 20 ottobre 2026",
  },

  // Diventa volontario
  diventaVolontario: {
    title: "Diventa volontario",
    subtitle: "Entrare in AVPS significa far parte di una famiglia che ogni giorno si impegna per gli altri. Ti formiamo, ti affianchiamo, ti facciamo crescere.",
    perche: "Perché diventare volontario?",
    reasons: [
      { title: "Aiutare gli altri", desc: "Ogni giorno fai la differenza nella vita di qualcuno." },
      { title: "Formazione gratuita", desc: "Ti formiamo noi: corsi di primo soccorso, BLSD e molto altro." },
      { title: "Una famiglia", desc: "Entrerai in un gruppo unito, motivato e accogliente." },
      { title: "Flessibilità", desc: "Scegli tu quando e quanto dedicare: ogni contributo conta." },
    ],
    candidatiOra: "Candidati ora",
    candidatiDesc: "Compila il modulo e ti contatteremo per il primo colloquio conoscitivo.",
    disponibilita: "Disponibilità",
    seleziona: "Seleziona",
    mattina: "Mattina",
    pomeriggio: "Pomeriggio",
    sera: "Sera",
    weekend: "Weekend",
    flessibile: "Flessibile",
    noteLabel: "Note",
    notePlaceholder: "Raccontaci qualcosa di te e delle tue motivazioni...",
    inviaBtn: "Invia candidatura",
  },

  // Iniziative
  iniziative: {
    title: "Iniziative",
    subtitle: "I nostri progetti speciali e le collaborazioni con altre associazioni del territorio.",
    stellaTitle: "Una stella in ambulanza",
    stellaDesc: "Un progetto speciale che unisce solidarietà e vicinanza, portando un sorriso a chi si trova in un momento difficile.",
    progettiTitle: "Progetti con altre associazioni",
    progettiDesc: "Collaborazioni con le realtà del territorio per iniziative di solidarietà, formazione e sensibilizzazione.",
    learnMore: "Scopri di più",
  },

  // Stella in ambulanza
  stella: {
    title: "Una stella in ambulanza",
    subtitle: "Impacchettare regali e distribuire stelle di Natale per sostenere la formazione e i mezzi di soccorso.",
    whatTitle: "Il progetto",
    whatText: "Questa è una iniziativa che ha come obiettivo principale quello di impacchettare i regali di Natale e distribuire le stelle di Natale in cambio di una donazione.",
    historyTitle: "La storia",
    historyText: "Il progetto è iniziato nel 1999 con un banchetto presso il mercato di Vimercate e dal 2001 si è sempre svolto presso la galleria dei negozi nel centro commerciale \"Torri Bianche\" di Vimercate.",
    detailText: "Tutti gli anni inizia dal 7 dicembre e termina la vigilia di Natale: i nostri volontari sono presenti in tutti i week end ed in genere in diverse giornate che precedono il Natale. Le nostre volontarie si sono specializzate nel realizzare bellissimi pacchetti e le nostre stelle di Natale provengono direttamente da un vivaio della zona: molte persone tornano ogni anno a trovarci!",
    fundsText: "I fondi raccolti sono utilizzati per investire nella formazione dei soccorritori, migliorando la qualità dell'assistenza e nell'acquisto di dispositivi medici per le nostre ambulanze.",
    contact: "Per ulteriori informazioni:",
  },

  // Progetti associazioni
  progetti: {
    title: "Progetti con altre associazioni",
    subtitle: "Avps collabora attivamente con alcune associazioni del territorio.",
    intro: "Avps collabora attivamente con alcune associazioni del territorio, questi sono i progetti:",
    items: [
      {
        title: "Raccolta tappi di sughero e plastica per FMS",
        text: "A fianco della divisione di Ematologia dell'Ospedale Niguarda – sostiene progetti di ricerca, studi clinici, borse di studio nonché l'acquisto di beni per i laboratori di ricerca.",
        hasLetter: true,
      },
      {
        title: "Raccolta di ramini per Ass. Mani di Pace ODV",
        text: "Con il progetto \"CASA KILT\" provvede all'ospitalità ed alla cura dei bambini orfani o abbandonati nella comunità di Siem Reap in Cambogia. Raccogliamo 1, 2 e 5 centesimi per sostenere questa causa.",
        hasPhoto: true,
      },
      {
        title: "Raccolta indumenti per Opera San Vincenzo Vimercate",
        text: "Raccolta di indumenti e biancheria varia (da letto, da bagno…) per aiutare le persone in difficoltà nel nostro territorio.",
      },
      {
        title: "\"Azalee della Ricerca\" per AIRC",
        text: "AVPS sostiene AIRC (Associazione Italiana Ricerca sul Cancro). Nel maggio 2025 abbiamo organizzato un banchetto per la distribuzione delle azalee della ricerca.",
        hasPhoto: true,
      },
    ],
    piantumazione: "Negli anni abbiamo seguito diversi progetti di piantumazione nel comune di Vimercate con piante provenienti dal Vivaio di Ersaf a Curno (Ente Regionale per i Servizi all'Agricoltura e alle Foreste).",
    ambulanzaSenegalTitle: "Un'ambulanza per Niakhene",
    ambulanzaSenegalText: "Siamo felicissimi di aver contribuito con la donazione della nostra ambulanza VIME40 al progetto \"Un'ambulanza per Niakhene\" dell'associazione ON OFF. L'ambulanza è arrivata alla sua destinazione presso il Centro di salute Ndemene in Senegal e dal mese di dicembre 2025 è operativa! Sarà di grande aiuto alla popolazione del luogo.",
    referenteTitle: "Informazioni",
    referenteText: "Per eventuali informazioni contattare il nostro referente Colombo Davide via email",
    referenteEmail: "davide.colombo@avps.it",
    referenteTel: "338 968 7658",
  },

  // Dati 2025
  stats2025: {
    title: "I numeri del 2025",
    subtitle: "L'attività di AVPS nel 2025 in numeri.",
    kmTitle: "Chilometri percorsi",
    kmItems: [
      { label: "Trasporto secondario Agrate Brianza", value: "60.338" },
      { label: "Trasporto secondario Concorezzo (nov-dic)", value: "10.645" },
      { label: "Trasporto secondario Vimercate sede", value: "56.863" },
      { label: "Logistica", value: "30.495" },
      { label: "Continuità Assistenziale", value: "2.628" },
      { label: "Urgenza Emergenza", value: "245.948" },
    ],
    kmTotale: "406.917",
    missioniTitle: "Missioni",
    missioniItems: [
      { label: "Gettone", value: "264" },
      { label: "Arcore", value: "1.785" },
      { label: "Agrate", value: "4.161" },
      { label: "Cornate", value: "669" },
      { label: "Monza", value: "1.927" },
      { label: "Vimercate", value: "4.937" },
      { label: "Servizi secondari Vimercate", value: "1.011" },
      { label: "Transiti e recupero OK", value: "827" },
      { label: "Servizio provette", value: "152" },
      { label: "Servizio TSS Agrate", value: "1.462" },
      { label: "Servizio TSS Concorezzo (nov-dic)", value: "856" },
    ],
    missioniTotale: "18.057",
    totaleLabel: "Totale",
  },

  // News
  newsPage: {
    title: "News ed eventi",
    subtitle: "Le ultime novità, gli aggiornamenti e gli eventi di AVPS.",
    news: "News",
    eventi: "Eventi",
    listHeading: "Ultime news dall'Associazione",
    ctaTitle: "Vuoi fare la differenza?",
    ctaDesc: "Unisciti ai nostri volontari o sostieni le nostre attività.",
    newsItems: [
      { title: "Nuova ambulanza per la postazione di Vimercate", date: "15 Febbraio 2026", category: "Associazione", excerpt: "Un nuovo mezzo di soccorso si aggiunge alla nostra flotta." },
      { title: "Corso BLSD aperto alla cittadinanza", date: "10 Febbraio 2026", category: "Formazione", excerpt: "Nuovo ciclo di corsi BLSD laici: 5 ore per imparare a salvare una vita." },
      { title: "AVPS al fianco della comunità: bilancio 2025", date: "5 Gennaio 2026", category: "Associazione", excerpt: "Un anno di impegno, numeri e risultati al servizio del territorio." },
    ],
  },

  // Eventi
  eventiPage: {
    title: "Eventi e attività",
    subtitle: "Tutti gli appuntamenti organizzati e supportati da AVPS: formazione, solidarietà, esercitazioni e iniziative per la comunità.",
    prossimiAppuntamenti: "Prossimi appuntamenti",
    prossimiDesc: "Non perderli! Iscriviti o partecipa.",
    nessunoEvento: "Al momento non ci sono eventi in programma. Seguici sui social per restare aggiornato!",
    partecipa: "Vuoi partecipare attivamente?",
    partecipaDesc: "Diventa volontario AVPS: ti formiamo noi e fai la differenza ogni giorno.",
    attivitaSvolte: "Attività svolte",
    attivitaSvolteDesc: "Le attività e gli eventi che ci hanno visto protagonisti.",
    iscrivitiOra: "Iscriviti ora",
    eventiPassati: [
      { title: "Una Stella in Ambulanza – Natale 2024", date: "24 Dicembre 2024", location: "Ospedale di Vimercate", type: "Iniziativa solidale", excerpt: "I Babbo Natale di AVPS hanno portato regali e sorrisi ai bambini ricoverati nel reparto di pediatria." },
    ],
  },

  // Contatti
  contattiPage: {
    title: "Contatti",
    subtitle: "Hai bisogno di informazioni? Siamo qui per te. Chiamaci, scrivici o passa a trovarci in sede.",
    scrivici: "Scrivici",
    informazioni: "Informazioni",
    telefono: "Telefono",
    email: "Email",
    orariUfficio: "Orari ufficio",
    orariValue: "Lun–Ven 9:00–13:00",
    leSedi: "Le nostre sedi",
  },

  // Le sedi
  leSediPage: {
    title: "Le nostre sedi",
    subtitle: "Quattro sedi operative per coprire al meglio il territorio.",
  },

  // Lavora con noi
  lavoraConNoi: {
    title: "Lavora con noi",
    subtitle: "Siamo alla ricerca di persone motivate per unirsi al nostro Team di soccorritori! Se vuoi lavorare in un ambiente dinamico e stimolante inviaci il tuo curriculum!",
    posizione: "Posizione aperta: Autista Soccorritore",
    requisiti: "Requisiti",
    requisitiItems: [
      "Certificazione come Soccorritore Esecutore",
      "Eventuali qualifiche di Autista e Capo Servizio",
      "Disponibilità a lavorare su turni",
    ],
    offriamo: "Cosa offriamo",
    offriamoItems: [
      "Contratto a tempo determinato per il periodo estivo (giugno/settembre) con possibilità di stabilizzazione",
      "Formazione continua con aggiornamento professionale",
      "Possibilità di crescita professionale",
    ],
    cvUploadLabel: "Allega il tuo CV",
    cvMaxSize: "Dimensione massima: 4MB – PDF, DOC, DOCX",
    cvTooLarge: "Il file supera la dimensione massima di 4MB.",
    cvUploadError: "Errore nel caricamento del file. Riprova.",
    inviaCandidatura: "Invia la tua candidatura",
    presentazione: "Lettera di presentazione",
    presentazionePh: "Invia il tuo curriculum ed una lettera di presentazione...",
    inviaBtn: "Invia candidatura",
    alternativa: "Invia il tuo curriculum ed una lettera di presentazione alla mail:",
  },

  // Sostienici
  sostieniciPage: {
    title: "Sostieni AVPS",
    subtitle: "Ogni giorno ci impegniamo al massimo per servire la nostra comunità. Ma le nostre sole forze non bastano, abbiamo bisogno di persone generose come te.",
    aiutaci: "Aiutaci ad aiutarti",
    aiutaciText: "Senza il tuo aiuto, la nostra attività non sarebbe possibile. Con il tuo sostegno potremo acquistare nuovi mezzi di soccorso e strumentazioni all'avanguardia e ne investiremo una parte per erogare corsi di formazione per i nostri volontari.",
    comeSostenerci: "Puoi sostenerci in diversi modi:",
    dona5x: "Donare il 5×1000",
    dona5xText: "Indica il nostro codice fiscale nell'apposito riquadro nel tuo Modello Unico o nel 730. Non ti costa nulla!",
    codiceFiscale: "Codice Fiscale",
    bonifico: "Fare un bonifico",
    bonificoText: "Sul conto intestato ad AVPS presso BCC Milano – Vimercate.",
    bonificoCausale: "Ricordati di scrivere il tuo indirizzo nella causale, così potremo ringraziarti.",
    cards: [
      { title: "5×1000 e donazioni", desc: "Destina il tuo 5×1000 ad AVPS o fai una donazione diretta. Ogni contributo ci aiuta a migliorare i nostri servizi." },
      { title: "Diventa amico di AVPS", desc: "Con una donazione annuale o ricorrente puoi sostenere le nostre attività in modo continuativo." },
    ],
    learnMore: "Scopri di più",
  },

  // Donazioni 5x1000
  donazioni: {
    title: "Sostieni AVPS",
    subtitle: "Ogni giorno ci impegniamo al massimo per servire la nostra comunità. Ma le nostre sole forze non bastano, abbiamo bisogno di persone generose come te.",
    aiutaci: "Aiutaci ad aiutarti",
    aiutaciText: "Senza il tuo aiuto, la nostra attività non sarebbe possibile. Con il tuo sostegno potremo acquistare nuovi mezzi di soccorso e strumentazioni all'avanguardia e ne investiremo una parte per erogare corsi di formazione per i nostri volontari.",
    dona5x: "Dona il tuo 5×1000",
    dona5xText: "Non ti costa nulla: indica il nostro codice fiscale nell'apposito riquadro nel tuo Modello Unico o nel 730.",
    codiceFiscale: "Codice Fiscale AVPS",
    cfCopiato: "Codice fiscale copiato negli appunti",
    bonifico: "Fai un bonifico",
    bonificoText: "Puoi sostenere AVPS con un bonifico bancario sul conto intestato ad AVPS presso BCC Milano – Vimercate.",
    ibanCopiato: "IBAN copiato negli appunti",
    intestatario: "Intestato a: Associazione Volontari di Pronto Soccorso e Pubblica Assistenza",
    causale: "Ricordati di scrivere il tuo indirizzo nella causale, così potremo ringraziarti.",
    donaCarta: "Dona con carta di credito",
    donaCartaText: "Compila il modulo qui sotto per effettuare una donazione. Ti ricontatteremo per completare il pagamento.",
    noteLabel: "Note sulla donazione",
    notePlaceholder: "Importo e modalità preferita...",
    inviaBtn: "Invia richiesta donazione",
    info: "Per informazioni:",
  },

  // Diventa amico
  diventaAmicoPage: {
    title: "Diventa amico di AVPS",
    subtitle: "Con una donazione annuale o ricorrente puoi sostenere le nostre attività in modo continuativo.",
    text: "Diventare \"Amico di AVPS\" significa scegliere di sostenerci in modo ricorrente, con una piccola donazione annuale che ci permette di pianificare e migliorare i nostri servizi.",
    comeAderire: "Come aderire",
    comeAderireText: "Per aderire al programma \"Amico di AVPS\" o per ricevere informazioni, contattaci:",
    ctaBtn: "Scrivi a amici@avps.it",
  },

  // Lascito testamentario
  lascito: {
    title: "Lascito testamentario",
    subtitle: "Un gesto di grande generosità che lascia un segno duraturo nella comunità.",
    heading: "Lascia un segno che dura nel tempo",
    p1: "Un lascito testamentario a favore di AVPS è un atto di straordinaria generosità che permette di sostenere il soccorso sanitario e i servizi alla comunità anche in futuro. Può trattarsi di una somma di denaro, di beni mobili o immobili.",
    p2: "Il lascito testamentario non pregiudica i diritti degli eredi legittimi: è un modo per destinare una quota del proprio patrimonio a una causa in cui si crede.",
    info: "Per informazioni riservate:",
  },

  // Privacy
  privacyPage: {
    title: "Informativa sulla Privacy",
    subtitle: "Informativa sul trattamento dei dati personali ai sensi del Regolamento UE 2016/679 (GDPR).",
  },
  cookiePage: {
    title: "Cookie Policy",
    subtitle: "Informazioni sull’uso dei cookie e di eventuali contenuti di terze parti presenti sul sito.",
  },

  // Banner Lavora con noi (home)
  lavoraBanner: {
    title: "Lavora con noi",
    badge: "Posizione aperta",
    text: "Cerchiamo un Autista Soccorritore da inserire nel nostro team! Contratto estivo (giugno–settembre) con possibilità di stabilizzazione.",
    highlights: [
      "Certificazione Soccorritore Esecutore",
      "Turni flessibili",
      "Formazione continua",
    ],
    cta: "Candidati ora",
  },

  // 404
  notFound: {
    title: "404",
    text: "Oops! Pagina non trovata",
    link: "Torna alla home",
  },
};
